var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('strong',[_vm._v(_vm._s(_vm.message.data.name)+":")]),_vm._v(" "+_vm._s(_vm.message.data.message)+" "),_c('small',[_vm._v("("),_c('time-ago',{staticStyle:{"font-size":"x-small"},attrs:{"datetime":_vm.message.timestamp}}),_vm._v(")")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }